import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { CtaButton } from '../ui/CtaButton';
import { withPlan, withoutPlan } from '../../data/comparison';
import { DELIVERY_NOTE } from '../../data/site';
export function FinalComparison() {
  return <section aria-labelledby="final-title" className="bg-deepest py-20 text-white lg:py-24" data-id="element-179" data-mp="3f0d81g7rhyti">
      <div className="mx-auto max-w-page px-5 lg:px-8" data-id="element-180" data-mp="2r8y3dgsij5f3">
        <SectionHeading id="final-title" eyebrow="Your choice" lead="Your next handball unit:" highlight="two ways to start" data-id="element-181" data-mp="2rbkka71amx9z" />

        <div className="mx-auto mt-12 grid max-w-4xl gap-5 md:grid-cols-2" data-id="element-182" data-mp="30bqu9ixs9f4e">
          <div className="rounded-xl border border-white/15 bg-ink/40 p-6 sm:p-8" data-id="element-183" data-mp="2w7rjlgz6paiy">
            <h3 className="font-display text-[26px] font-bold uppercase leading-none text-white/90" data-id="element-184" data-mp="fjfazf5hjtxp">Without a plan</h3>
            <ul className="mt-6 space-y-3.5" data-id="element-185" data-mp="bhtnz0z8lz9s">
              {withoutPlan.map(item => <li key={item} className="flex gap-3 text-base text-white/80" data-id="element-186" data-mp="2uwl6zi8elluq">
                  <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 border-alert text-alert" data-id="element-187" data-mp="2zw7rmcqka4dk">
                    <XIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-188" data-mp="33w8aqaolv3qy" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="rounded-xl border-2 border-gold bg-pine p-6 sm:p-8" data-id="element-189" data-mp="2c8znvz8s73dn">
            <h3 className="font-display text-[26px] font-bold uppercase leading-none text-gold" data-id="element-190" data-mp="2g9jnrakqol3h">With Handball Class Ready</h3>
            <ul className="mt-6 space-y-3.5" data-id="element-191" data-mp="2l5qgu2s1e240">
              {withPlan.map(item => <li key={item} className="flex gap-3 text-base font-medium text-white" data-id="element-192" data-mp="2pzuoypd1gg6o">
                  <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-go text-ink" data-id="element-193" data-mp="1simjmjz6qs2s">
                    <CheckIcon className="h-3.5 w-3.5" strokeWidth={3.5} data-id="element-194" data-mp="30t684sktua7c" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div id="final-cta" className="mx-auto mt-14 max-w-[576px] rounded-xl border border-white/15 bg-forest p-6 text-center sm:p-10" data-id="element-195" data-mp="39l886pqzhoh3">
          <p className="text-[13px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-196" data-mp="35l6469xs0iyn">12 lessons + 5 bonuses</p>
          <p className="mt-3 font-display font-bold leading-none" data-id="element-197" data-mp="2hutyz6tx10br">
            <span className="text-[80px] sm:text-[96px]" data-id="element-198" data-mp="2cvz6fd65bxeg">$27</span>
            <span className="ml-2 align-top text-[26px]" data-id="element-199" data-mp="2cxjy8v12t28m">USD</span>
          </p>
          <p className="mt-2 text-[13px] font-bold uppercase tracking-[0.16em] text-white/80" data-id="element-200" data-mp="2qsvvb92pf4sp">One-time purchase</p>
          <CtaButton target="checkout" size="xl" className="mt-8 w-full" data-id="element-201" data-mp="2ly8frzpohkq9">
            Get the pack now
          </CtaButton>
          <p className="mt-6 text-base text-white/80" data-id="element-202" data-mp="166ael55ig8w">10-day money-back guarantee · {DELIVERY_NOTE}</p>
        </div>
      </div>
    </section>;
}